import tw from "twin.macro";

export const ButtonTextStyle = tw.p`
    px-4
    py-1
    font-bold
    `;
